import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Tag } from 'lucide-react';

const money = (n) => `$${Number(n).toLocaleString('en-US')}`;

// Sales-page setup-fee callout: regular vs promotional price + savings, driven by /public/plans (promo ends Jan 1, 2027).
export const SetupFeeBanner = ({ compact = false }) => {
  const [fee, setFee] = useState(null);
  useEffect(() => { axios.get('/public/plans').then((r) => setFee(r.data.setup_fee)).catch(() => {}); }, []);
  if (!fee) return null;
  const ends = new Date(`${fee.promo_ends}T12:00:00`).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  if (compact) {
    return (
      <p data-testid="setup-fee-compact" style={{ fontSize: 13, color: '#94A3B8', marginTop: 10 }}>
        One-time setup fee <b style={{ color: '#fff' }}>{money(fee.current)}</b>{fee.promo_active && <> <s>{money(fee.regular)}</s> — save {money(fee.savings)} through {ends}</>}, invoiced only when you choose to activate a paid plan after the trial — never charged automatically.
      </p>
    );
  }
  return (
    <div data-testid="setup-fee-banner" className="mt-8 rounded-2xl border border-indigo-500/40 bg-indigo-600/10 p-5">
      <div className="flex flex-wrap items-center gap-3">
        <span className="grid h-8 w-8 place-items-center rounded-lg bg-indigo-600 text-white"><Tag size={14} /></span>
        <div className="font-bold text-slate-100">One-time website setup fee — all plans</div>
        {fee.promo_active && <span data-testid="setup-fee-savings" className="rounded-full bg-emerald-500/15 px-3 py-1 text-xs font-bold text-emerald-300">Save {money(fee.savings)}</span>}
      </div>
      <div className="mt-3 flex flex-wrap items-baseline gap-x-4 gap-y-1">
        <span data-testid="setup-fee-current" className="text-3xl font-black text-white">{money(fee.current)}</span>
        {fee.promo_active && <span data-testid="setup-fee-regular" className="text-lg text-slate-500 line-through">{money(fee.regular)} regular</span>}
      </div>
      <p className="mt-2 text-sm text-slate-400">
        {fee.promo_active ? `Promotional pricing through ${ends}. From January 2, 2027 the regular ${money(fee.regular)} setup fee applies.` : `Standard setup fee of ${money(fee.regular)}.`}
        {' '}Covers your branded website, CRM configuration and onboarding. Never charged during the free 14-day trial — invoiced once, only when you choose to activate a paid plan. It is never charged automatically.
      </p>
    </div>
  );
};
